"use strict";
export const BSC_TOKEN_LOGOS = {
  // ============ BSC Testnet (chainId 97) ============
  // WBNB (canonical Binance-deployed)
  "0xae13d989dac2f0debff460ac112a837c89baa7cd": "/images/tokens/wbnb-logo.png",
  // TOPAZ
  "0xdf002282c1474c9592780618adda7eaa99998abd": "/images/tokens/topaz-logo.png",
  // USDC
  "0x878566c3c680039ce7655ea3bb1ca5ca7507aa32": "/images/tokens/usdc-logo.png",
  // USDT
  "0x764bf419ed27979713f197cbe1416a1695f639fa": "/images/tokens/usdt-logo.png",
  // ETH (Binance-Peg)
  "0xaaf5f2bb24f04ca6139c4eb153d650c3278276f3": "/images/tokens/eth-logo.png",
  // BTCB
  "0xf9750a1d19b70fca58fab8410ec57c43e9fe035a": "/images/tokens/btcb-logo.png",
  // CAKE
  "0x3221ac6a80028efc71d501d853e3cc1829e31b08": "/images/tokens/cake-logo.png",
  // ============ BSC Mainnet (chainId 56) ============
  // WBNB (canonical Binance-deployed)
  "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c": "/images/tokens/wbnb-logo.png",
  // TOPAZ (mainnet shares testnet address — entry above already covers it, repeated here for clarity)
  // USDC
  "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d": "/images/tokens/usdc-logo.png",
  // USDT
  "0x55d398326f99059ff775485246999027b3197955": "/images/tokens/usdt-logo.png",
  // USD1
  "0x8d0d000ee44948fc98c9b98a4fa4921476f08b0d": "/images/tokens/usd1-logo.png",
  // ETH (Binance-Peg)
  "0x2170ed0880ac9a755fd29b2688956bd959f933f8": "/images/tokens/eth-logo.png",
  // BTCB
  "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c": "/images/tokens/btcb-logo.png",
  // SOL (Binance-Peg)
  "0x570a5d26f7765ecb712c0924e4de545b89fd43df": "/images/tokens/sol-logo.png",
  // CAKE
  "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82": "/images/tokens/cake-logo.png",
  // FDUSD
  "0xc5f0f7b66764f6ec8c8dff7ba683102295e16409": "/images/tokens/fdusd-logo.png",
  // DOGE
  "0xba2ae424d960c26247dd6c32edc70b295c744c43": "/images/tokens/doge-logo.png",
  // XRP
  "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe": "/images/tokens/xrp-logo.png",
  // BOOK
  "0xc9ad421f96579ace066ec188a7bba472fb83017f": "/images/tokens/book-logo.png",
  // BLUE
  "0xa90298e5b1203a2dd0006a75eabe158989c406fb": "/images/tokens/blue-logo.png",
  // GBLUE
  "0x158ff17474d7acd29c13f26c5d27b293ef0a1410": "/images/tokens/gblue-logo.png",
  // ClipX
  "0xc269d59a0d608ea0bd672f2f4616c372d8554444": "/images/tokens/clipx-logo.png",
  // BUD
  "0xc28957e946ac244612bcb205c899844cbbcb093d": "/images/tokens/bud-logo.png",
  // BUSS
  "0xfc35bf79270bcad22ce7dd5651aa2435fce9b7c5": "/images/tokens/buss-logo.png",
  // BULLA
  "0x595e21b20e78674f8a64c1566a20b2b316bc3511": "/images/tokens/bulla-logo.jpg",
  // SIREN
  "0x997a58129890bbda032231a52ed1ddc845fc18e1": "/images/tokens/siren-logo.png",
  // PUP
  "0x73b84f7e3901f39fc29f3704a03126d317ab4444": "/images/tokens/pup-logo.jpg",
  // 4
  "0x0a43fc31a73013089df59194872ecae4cae14444": "/images/tokens/four-logo.jpg",
  // PALU
  "0x02e75d28a8aa2a0033b8cf866fcf0bb0e1ee4444": "/images/tokens/palu-logo.jpg",
  // bibi
  "0x9212cf1f9f4a9c69bb010146ba5b0725169d4444": "/images/tokens/bibi-logo.jpg",
  // Broccoli
  "0x12b4356c65340fb02cdff01293f95febb1512f3b": "/images/tokens/broccoli-logo.png",
  // CaptainBNB
  "0x47a1eb0b825b73e6a14807beaecafef199d5477c": "/images/tokens/captainbnb-logo.png",
  // NianNian
  "0x9c27c4072738cf4b7b0b7071af0ad5666bddc096": "/images/tokens/niannian-logo.jpg",
  // $RISE
  "0x64fdd8a6c19d66a5b917a015868c5611261c4444": "/images/tokens/rise-logo.jpg",
  // intCLAW
  "0xf3c571aa528c03d64fa825af7bc544fd1953ffff": "/images/tokens/intclaw-logo.png",
  // Trusty
  "0x65aea108c21439693468fcd542d81c29e8df4444": "/images/tokens/trusty-logo.jpg",
  // Earn
  "0x2ac895feba458b42884dcbcb47d57e44c3a303c8": "/images/tokens/earn-logo.jpg",
  // xPBNB
  "0xcc935be86c9a12837cc2c27b43fa2f8aa69affff": "/images/tokens/xpbnb-logo.jpg",
  // BUILD4 (B4)
  "0x1d547f9d0890ee5abfb49d7d53ca19df85da4444": "/images/tokens/build4-logo.jpg",
  // 背手负鼠
  "0x5f6fd60ad6cd8751b4c521bc00fa02abfeca4444": "/images/tokens/beishoufushu-logo.jpg",
  // TWT
  "0x4b0f1812e5df2a09796481ff14017e6005508003": "/images/tokens/twt-logo.png",
  // UB
  "0x40b8129b786d766267a7a118cf8c07e31cdb6fde": "/images/tokens/ub-logo.png",
  // B
  "0x6bdcce4a559076e37755a78ce0c06214e59e4444": "/images/tokens/b-logo.png",
  // SKYAI
  "0x92aa03137385f18539301349dcfc9ebc923ffb10": "/images/tokens/skyai-logo.png",
  // GENIUS
  "0x1f12b85aac097e43aa1555b2881e98a51090e9a6": "/images/tokens/genius-logo.png",
  // 币安人生
  "0x924fa68a0fc644485b8df8abfa0a41c2e7744444": "/images/tokens/bianrensheng-logo.jpg",
  // STNK
  "0xa1c9ae1ac8b55edcd580930263d180c647044444": "/images/tokens/stonks-logo.jpg",
  // GRASS
  "0xf43ac1e44bcb375d318d4fa265eff191a229c8db": "/images/tokens/grass-logo.png",
  // ZEC
  "0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb": "/images/tokens/zec-logo.png",
  // SPCXon
  "0xd0a58bc9d88d3ff48c0294cb7e45937d0e41a928": "/images/tokens/spcxon-logo.png",
  // VELVET
  "0x8b194370825e37b33373e74a41009161808c1488": "/images/tokens/velvet-logo.jpg",
  // Korico
  "0xbb87dc5daac59d6e11ea2461ca69543f4b844444": "/images/tokens/korico-logo.jpg",
  // ASTER
  "0x000ae314e2a2172a039b26378814c252734f556a": "/images/tokens/aster-logo.png"
};
export function getTokenLogoUrl(address, _chainId) {
  if (!address) return null;
  const normalizedAddress = address.toLowerCase();
  return BSC_TOKEN_LOGOS[normalizedAddress] ?? null;
}
